<template>
  <div>
    <div class="uk-column-1-2 uk-column-divider">
      <div>
        <h3 class="uk-text-center main-title">Ready to start<br/> the Assessment?</h3>
        <p style="height: 50px;">Enter the unique code you received after purchasing the assessment</p>
        <div class="uk-text-center"><router-link to="/register" class="uk-button uk-button-primary">Start assessment</router-link></div>
      </div>
      <div>
        <h3 class="uk-text-center main-title">Don’t have the code yet?</h3>
        <p style="height: 50px;">To learn more about what you will receive with the Genius Blueprint Assessment and to get your access code, click the button below</p>
        <div class="uk-text-center"><a class="uk-button uk-button-primary" href="https://www.leap2genius.com/checkout/"  target="_blank">Purchase Now</a></div>
      </div>
    </div>
    <div class="uk-text-center main-link">
      To learn more about Genius Blueprint Assessment click below<br/>
      <div><a href="https://www.leap2genius.com/genius-blueprint-assessment/" target="_blank">Genius Blueprint Assessment</a></div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Main'
}
</script>

<style>

</style>